import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';

import './SMAssetBindingModal.css';
import { Modal, Button, Transfer, Spin } from 'antd';

@inject('translationsStore')
@observer
export default class SMAssetBindingModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mockData: [],
      targetKeys: []
    };
  }

  componentDidMount() {
    this.getMock();
  }

  getMock = () => {
    const targetKeys = [];
    const mockData = [];
    for (let i = 0; i < 20; i++) {
      const data = {
        key: i.toString(),
        title: `content${i + 1}`,
        description: `description of content${i + 1}`,
        chosen: Math.random() * 2 > 1
      };
      if (data.chosen) {
        targetKeys.push(data.key);
      }
      mockData.push(data);
    }
    this.setState({ mockData, targetKeys });
  };

  handleChange = (...params) => {
    const { serviceManager } = this.props;
    this.props.onChange instanceof Function && this.props.onChange(serviceManager.id, ...params);
  };

  render() {
    const { translationsStore, visible, loading, bindingError, dataSource, targetKeys, serviceManager = {} } = this.props;
    const commonName =
      serviceManager.name === '' && serviceManager.surname === ''
        ? serviceManager.companyName
        : `${serviceManager.name} ${serviceManager.surname}${serviceManager.companyName !== '' ? `, ${serviceManager.companyName}` : ''}`;
    return (
      <Fragment>
        {visible && (
          <Modal
            title={translationsStore.translate('serviceManagers.assetsBinding.modal.title')}
            visible={visible}
            footer={null}
            onOk={this.props.onOk}
            onCancel={this.props.onCancel}
            width={760}
            className="FMAssetBinding"
          >
            <div className="AssetBindingserviceManager" style={{ marginBottom: 20 }}>
              <div className="FieldserviceManager">{translationsStore.translate('serviceManagers.assetsBinding.modal.labelServiceManager')}</div>
              <div className="ValueserviceManager">{commonName}</div>
            </div>
            <div className="AssetBindingColumns">
              <div>{translationsStore.translate('serviceManagers.assetsBinding.modal.labelAvailableAssets')}</div>
              <div></div>
              <div>{translationsStore.translate('serviceManagers.assetsBinding.modal.labelAssignedAssets')}</div>
            </div>
            <Spin spinning={!!loading}>
              <Transfer
                className="TransferBinding"
                dataSource={dataSource}
                targetKeys={targetKeys}
                showSearch={true}
                listStyle={{}}
                onChange={this.handleChange}
                render={item => `${item.title}`}
                locale={{ itemUnit: translationsStore.translate('serviceManagers.assetsBinding.modal.labelElement'), itemsUnit: translationsStore.translate('serviceManagers.assetsBinding.modal.labelElements'), notFoundContent: translationsStore.translate('serviceManagers.assetsBinding.modal.labelNoElement'), searchPlaceholder: translationsStore.translate('serviceManagers.assetsBinding.modal.labelAssetFilter') }}
              />
            </Spin>
            {bindingError && <div style={{ margin: '20px 0', display: 'flex', alignItems: 'center' }}>{bindingError}</div>}
          </Modal>
        )}
      </Fragment>
    );
  }
}
